import comp from "./QuestionInsightsField";
export default comp;
